import MarketplaceCategoryModel from '../models/MarketplaceCategoryModel';
import MarketplaceCategoryService from '../services/MarketplacesCategoriesService';

export default {
  data() {
    return {
      loading: true,
      model: MarketplaceCategoryModel.getDefaults(),
    };
  },
  methods: {
    $marketplacesCategory_save() {
      this.loading = true;
      const data = MarketplaceCategoryModel.toApiRequest(this.model);
      MarketplaceCategoryService.update(this.model.id, data).then(() => {
        this.loading = false;
        this.$toastr.success(this.$t('Action', { object: this.$t('Category'), action: this.$t('updated') }), this.$t('Success'));
        this.$marketplacesCategory_load(this.model.id);
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
        this.loading = false;
      });
    },
    $marketplacesCategory_load(id) {
      this.loading = true;
      MarketplaceCategoryService.findById(id).then(data => {
        this.model = MarketplaceCategoryModel.fromApiResponse(data);
        this.loading = false;
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
        this.loading = false;
      });
    },
  },
};
